/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Edit_ForceInputs */

const en_forms_teams_edit_force = /** @type {(inputs: Forms_Teams_Edit_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force`)
};

const de_forms_teams_edit_force = /** @type {(inputs: Forms_Teams_Edit_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force`)
};

/**
* | output |
* | --- |
* | "Force" |
*
* @param {Forms_Teams_Edit_ForceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_edit_force = /** @type {((inputs?: Forms_Teams_Edit_ForceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Edit_ForceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_edit_force(inputs)
	return de_forms_teams_edit_force(inputs)
});